"use strict";
// tslint:disable: no-shadowed-variable
Object.defineProperty(exports, "__esModule", { value: true });
const E = require("fp-ts/lib/Either");
const _1 = require(".");
function required(path) {
    return (value) => {
        if (value == null || value.trim().length === 0) {
            return E.left([
                new _1.ValidationError(path, 'is required', new RequiredInfo()),
            ]);
        }
        return E.right(value);
    };
}
exports.required = required;
class RequiredInfo {
    constructor() {
        this.type = 'required';
    }
}
exports.RequiredInfo = RequiredInfo;
function minLength(path, minLength) {
    return value => {
        if (value.length < minLength) {
            return E.left([
                new _1.ValidationError(path, `${value} is shorter than ${minLength}`, new MinLengthInfo(minLength)),
            ]);
        }
        return E.right(value);
    };
}
exports.minLength = minLength;
class MinLengthInfo {
    constructor(minLength) {
        this.minLength = minLength;
        this.type = 'minLength';
    }
}
function maxLength(path, maxLength) {
    return value => {
        if (value.length > maxLength) {
            return E.left([
                new _1.ValidationError(path, `${value} is longer than ${maxLength}`, new MaxLengthInfo(maxLength)),
            ]);
        }
        return E.right(value);
    };
}
exports.maxLength = maxLength;
class MaxLengthInfo {
    constructor(maxLength) {
        this.maxLength = maxLength;
        this.type = 'maxLength';
    }
}
function onlyDigits(path) {
    return value => {
        if (!value.match('^[0-9]+$')) {
            return E.left([
                new _1.ValidationError(path, `${value} must be digits only`, new OnlyDigitsInfo()),
            ]);
        }
        return E.right(value);
    };
}
exports.onlyDigits = onlyDigits;
class OnlyDigitsInfo {
    constructor() {
        this.type = 'digitsOnly';
    }
}
